import {
  Component,
  EventEmitter,
  Input, OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { DynamicFormModel, KeyValuePair } from './models/dynamic-form-model';
import { KeyValue } from '@angular/common';
import { ApiService } from './services/api.service';
import { Subscription } from "rxjs";

@Component({
  selector: 'ebw-monorepo-filter-table',
  templateUrl: './filter-table.component.html',
  styleUrls: ['./filter-table.component.scss'],
})
export class FilterTableComponent implements OnInit, OnDestroy {
  @Output() filterObjectHendler: EventEmitter<KeyValuePair> =
    new EventEmitter<KeyValuePair>();

  // Evento emesso in caso debbano essere visualizzati nel componente esterno dei messaggi d'errore custom
  @Output() customErrorObj: EventEmitter<any> = new EventEmitter<any>(); 

  @Input() model?: DynamicFormModel[];
  dynamicFormGroup: FormGroup;
  fields: DynamicFormModel[] = [];
  appliedFilter: KeyValuePair = {};
  numFilter: number = 0;
  showFilter = false;
  enableSendFilter: boolean = false;
  sub: Subscription;

  constructor(private as: ApiService) { }

  ngOnInit(): void {
    this.buildForm();
    this.sub = this.dynamicFormGroup.valueChanges.subscribe((value) => {
      let arr = [];
      for (const key in value) {
        if (value[key]) arr = [value[key]];
      }

      this.enableSendFilter = arr.length > 0;
      this.filterManagement();
    });
  }

  sendFilter(dynamicFormGroup: FormGroup) {
    this.numFilter = 0;
    this.appliedFilter = {};
    for (const field of this.fields) {
      let value = dynamicFormGroup.controls[field.filterKey].value;
      
      //controllo i valori dei date range e ignoro l'oggetto che ha start e end a null
      if (value && typeof value === 'object' && field.type == 'date_range' && !value["start"] && !value["end"]) {
        value = null;
        field.value = null;
      } else if (value && typeof value === 'object' && field.type == 'date') {
        value = value.format('YYYY-MM-DD');
      }
      else {
        field.value = value;
      }

      // Indica se il valore è stato trovato tra le options, quindi se è stato selezionato dalla lista oppure no
      let found = false;
      // Mappa la stringa selezionata dall'elenco nel rispettivo id
      if (field.options) {
        field.options.map((option) => {
          if (dynamicFormGroup.controls[field.filterKey].value === option.label){
            value = option.value;
            found = true;
          }
        });
      }

      // Controllo se è stata trovata una corrispondenza tra il valore digitato e uno degli elementi della lista (options)
      // freeSearch: false indica che la ricerca non è libera e il parametro deve essere per forza selezionato tra quelli della lista
      if(!!value && field.options && !found && field.freeSearch !== undefined && !field.freeSearch) 
      {
        this.customErrorObj.emit({error: 1, message:`Errore formato campo "${field.label.toUpperCase()}". Selezionare un valore dalla lista.`});
        return;
      }
      
      if (value) {
        this.numFilter += 1;
        this.appliedFilter = {
          ...this.appliedFilter,
          [field.filterKey]: value,
        };
      } else if (value === 0) {
        this.numFilter += 1;
        this.appliedFilter = {
          ...this.appliedFilter,
          [field.filterKey]: value,
        };
      }
    }
    this.as.formModel = this.fields;
    this.filterObjectHendler.emit(this.appliedFilter);
  }

  removeFilter() {
    this.numFilter = 0;
    this.appliedFilter = {};
    if (this.as.formModel && this.as.formModel.length) this.as.formModel = [];
    // for (const control in this.dynamicFormGroup.controls) {
    //   this.dynamicFormGroup.controls[control].reset();
    // }
    this.dynamicFormGroup.reset('');
    this.enableSendFilter = false;
    this.filterObjectHendler.emit(this.appliedFilter);
  }

  private buildForm() {
    const formGroupFields = this.getFormControlsFields();
    this.dynamicFormGroup = new FormGroup(formGroupFields);

    if (this.as.formModel && this.as.formModel.length) {
      this.showFilter = true;
      this.sendFilter(this.dynamicFormGroup);
    }
  }

  private getFormControlsFields() {
    const formGroupFields = {};

    if (this.as.formModel && this.as.formModel.length) {
      for (const fieldProps of Object.values(this.as.formModel)) {
        const fieldName = fieldProps.filterKey;

        if (fieldProps.type == 'date_range') {
          formGroupFields[fieldName] = new FormGroup({
            start: new FormControl(null),
            end: new FormControl(null),
          }, { validators: this.rangeDateValidator })
        } else {
          formGroupFields[fieldName] = new FormControl(fieldProps.value);
        }

        this.fields.push({ ...fieldProps, filterKey: fieldName });
      }
    } else {
      for (const fieldProps of Object.values(this.model)) {
        // eslint-disable-next-line no-prototype-builtins
        if (fieldProps && fieldProps.hasOwnProperty('filterKey')) {
          const fieldName = fieldProps.filterKey;
          if (fieldProps.type == 'date_range') {
            formGroupFields[fieldName] = new FormGroup({
              start: new FormControl(null),
              end: new FormControl(null),
            }, { validators: this.rangeDateValidator })
          } else {
            formGroupFields[fieldName] = new FormControl(fieldProps.value);
          }
          this.fields.push({ ...fieldProps, filterKey: fieldName });
        } else {
          console.error('Filter error', fieldProps);
        }
      }
    }

    return formGroupFields;
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
    this.removeFilter();
  }

  public rangeDateValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const start = control.get('start');
    const end = control.get('end');

    if (!start.value && !end.value) {
      return null;
    }


    return start.value !== null && end.value !== null && start.value <= end.value
      ? null : { dateValid: true };
  }

  private filterManagement() {
    if (Object.keys(this.appliedFilter).length == 1 && !this.enableSendFilter) {
      this.removeFilter();
    }
  }

}
